import React from 'react';
import { Link } from 'react-router-dom';
import "../css/footer.css"


function Footer() {
    const currentDate = new Date(); // Get the current date
    const year = currentDate.getFullYear();

    return (
      <footer>
          <img className='' src="/images/slogan.gif" alt='Slogan: Lets Win Together'/>

        <div className='footer-copyright'>
          <p></p>
          <p className='copyright'>&copy; Eastern for Trading {year}. All rights reserved.</p>
          <p className='nrldn'>Powered by <a href="https://nrldn.com" target='_blank'>nrldn</a></p>

    
        </div>
        
      </footer>
    );
  }

  export default Footer;


  